import React from 'react';
import Flex from 'ui/Flex/Flex';
import HomePageUrlForm from './HomePageUrlForm/HomePageUrlFrom';

const DecisionConfiguration = ({ client }: { client: ClientT }) => {
    const { bind, homePageUrl } = client;
    return (
        <Flex gap={2} margin={2} direction="column" justify="space-between">
            <HomePageUrlForm bind={bind} homePageUrl={homePageUrl} />
        </Flex>
    );
};

export default DecisionConfiguration;
